<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
             
                <div class="form-row">
                    <div class="col-md-11">
                            <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.user.type.list.label.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead class="thead-dark">
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.plans.label.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.plans.label.platforms')}}</th>
                                <th class="border-top-0">{{$t('string.msg.plans.usertypes')}}</th>
                                <th class="border-top-0">{{$t('string.msg.plans.additional.resources')}}</th>
                                <th class="border-top-0">{{$t('string.msg.plans.setup.price')}}</th>
                                <th class="border-top-0">{{$t('string.msg.plans.monthy.price')}}</th>
                                <th class="border-top-0">{{$t('string.msg.plans.status')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                            <tr v-if="item.status == 'ACTIVE'">
                                <td>
                                    <span v-if="item.name">
                                        {{camelize(item.name)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.platforms && item.platforms.length > 0">
                                        <span  v-bind:key="platform" v-for="platform in item.platforms">   
                                            <label v-if="platform.name" >{{camelize($t(platform.name))}}</label><br/> 
                                        </span>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.userTypes && item.userTypes.length > 0">
                                        <span  v-bind:key="users" v-for="users in item.userTypes">   
                                            <span v-if="users.user && users.user.name">
                                                <label v-if="users.user.name" >{{camelize(users.user.name) + ' - ' + $t('str.msg.quantity') + users.quantity }}</label><br/> 
                                            </span>
                                        </span>
                                    </span> 
                                </td>
                                <td>
                                    <span v-if="item.additionalResources && item.additionalResources.length > 0">
                                        <span  v-bind:key="addResources" v-for="addResources in item.additionalResources">   
                                            <label v-if="addResources.name" >{{camelize($t(addResources.name))}}</label><br/> 
                                        </span>
                                    </span> 
                                </td>
                                <td>
                                    <span v-if="item.setupPrice">
                                        {{'R$ ' + $t(item.setupPrice.toFixed(2))}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.monthlyPrice">
                                        {{'R$ ' + $t(item.monthlyPrice.toFixed(2))}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.status">
                                        {{$t(item.status)}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      <Spinner />
      <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtListPlans';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

export default {
  name: 'ListPlans',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        companyTypes: [],
        filters: {
            typeService: '',
            name: '',
            status:'ACTIVE',
        },
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
